/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function BugBeetle(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M50.416,33.7959A7.99956,7.99956,0,0,1,61.44336,22.2041L80.10742,39.959a79.84411,79.84411,0,0,1,95.70777-.05908L194.416,22.2041a7.99956,7.99956,0,1,1,11.02734,11.5918L187.63013,50.74268A79.69432,79.69432,0,0,1,207.59912,96H48.40088A79.69482,79.69482,0,0,1,68.30664,50.81543ZM32,96a8,8,0,0,0,0,16H48V96Zm176,56c0,2.7002-.13843,5.36816-.40088,8H224a8,8,0,0,1,0,16H204.31714a80.00273,80.00273,0,0,1-152.63428,0H32a8,8,0,0,1,0-16H48.40088C48.13843,157.36816,48,154.7002,48,152v-8H32a8,8,0,0,1,0-16H48V112H208v16h16a8,8,0,0,1,0,16H208Zm-72-16a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0Zm96-32a8.00039,8.00039,0,0,0-8-8H208v16h16A8.00039,8.00039,0,0,0,232,104Z" />
    </Svg>
  );
}

export default BugBeetle;
